// combatpro/panels/monsters/MonsterSearch.js
//
// Combat PRO - MonsterSearch (decomposition of MonsterPanel.js).
//
// Static markup only, moved verbatim from MonsterPanel.js: the search input and
// the filter toggle wrapper (the first two children of the search-section).
// These are returned as a fragment so the DOM nesting inside search-section is
// unchanged. IDs, class names, placeholder text, and order are preserved
// exactly. The input and button are inert (no handlers), exactly as in the
// source. No state, hooks, logic, searching, or filtering. Imports only React.
// Do not edit battletracker.html.

import React from 'react';

function MonsterSearch() {
  return (
    <>
      <input type="text" className="search-box" id="monsterSearch" placeholder="🔍 Search monsters by name..." />
      <div className="vi-filter-wrap">
        <button id="filterToggleBtn" className="vi-btn vi-btn-primary">🔽 Show Filters</button>
      </div>
    </>
  );
}

export default MonsterSearch;
